import React, { useEffect } from "react"
import classNames from "classnames"

import { HEADER_THEMES } from "../components/_V2/Header"

import { insertMangoCallback } from "../utils"

import AllSizedHelmet from "../components/AllSizedHelmet"
import SectionHeader from "../components/sections/SectionHeader"
import SectionFooter from "../components/sections/SectionFooter"

interface Props {
	children: React.ReactNode
	title: string
	metaTags: Record<string, string>[]
	linkCanonical: string

	mainWrapperClassName: string
}
export default function OldVersionLayout({
	children,
	title,
	metaTags,
	mainWrapperClassName,
	linkCanonical,
}: Props) {
	// Вставить скрипт через react-helmet не получается из-за
	// https://github.com/nfl/react-helmet/issues/419.
	// Добавить скрипт в скрипт по умолчанию в react-helmet'е (там, где Chatra) не
	// получается: возникают неопределённые переменные в скрипте от Mango.
	// Поэтому после монтирования странички создаём новый тег script
	// в body с содержимым виджета Mango:
	useEffect(() => {
		setTimeout(insertMangoCallback, 6500)
	})

	return (
		<>
			<main className={mainWrapperClassName}>
				<AllSizedHelmet>
					{/*<meta name="robots" content="noindex, nofollow" />*/}
					<meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
					<meta
						name="viewport"
						content="width=device-width, initial-scale=1, maximum-scale=5"
					/>
					<meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
					{Array.isArray(metaTags) &&
						metaTags.map((attrs: Record<string, string>) => (
							<meta {...attrs} />
						))}
					<title>{title}</title>
					<link rel="canonical" href={linkCanonical} />
				</AllSizedHelmet>

				<SectionHeader />
				{children}
				<SectionFooter />

				{/* Обратный звонок сервиса "Mango" */}
				<div
					className="mango-callback"
					data-settings='{"type":"", "id": "MTAwMDI1NjY=","autoDial" : "0", "lang" : "ru-ru", "host":"lk.mango-office.ru/", "errorMessage": "В данный момент наблюдаются технические проблемы и совершение звонка невозможно"}'
				>
					<button
						className="button-widget-open"
						id="mango-widget-btn"
						style={{ display: "none" }}
					>
						☎
					</button>
				</div>
			</main>
		</>
	)
}
